export default "__VITE_ASSET__CmM35F6c__"